import Modal from '@components/Modal';
import Button from '@components/Button';
import { useRef } from 'react';
import Icon from '@material-ui/core/Icon';
import TextField from '@components/TextField';

const RegionsCreateModal = (props) => {
  let ref = useRef(null);

  return <Modal open={props.open} close={props.close} style={{ width: '100%', maxWidth: '350px'}}>
    <div className="flex justify-between font-poppins">
      <div className="flex">
        <div className="flex flex-col">
          <span className="mb-3 text-xl text-blue">Nova região</span>
        </div>
      </div>
      <Icon ref={ref} className="cursor-pointer" onClick={props.close}>close</Icon>
    </div>
    <form>
      <div className="flex mt-4">
        <TextField
          className="inputRounded"
          label="Região"
          width="300px"
          variant="outlined"
          type="text"
          value={props.region}
          onChange={(e) => props.setRegion(e.target.value)}
        />
      </div>
      <div className="justify-center mt-4 md:flex w-100">
        <Button
          textcolor="#fff"
          padding="10px 15px"
          margintop="0px"
          width="300px"
          onClick={(ev) => props.onCreate(ev)}
          customcolor={props.theme.color}
        >
            Salvar
        </Button>
      </div>
    </form>
  </Modal>
}

export default RegionsCreateModal;
